/* ATARA ui: product form, set builder, gift finder */
(function () {
  'use strict';
  var A = window.Atara;
  var $ = A.$, $$ = A.$$, money = A.formatMoney;

  function initProduct(root) {
    var form = $('form[data-product-form]', root);
    if (!form || form._on) return; form._on = true;
    var dataEl = $('script[data-product-json]', root);
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = $('input[name="id"]', form);
    var addBtn = $('[data-add-btn]', form);
    var priceEl = $('[data-price]', root);
    var stickyPrice = $('[data-sticky-price]', root);
    var stickyBtn = $('[data-sticky-add]', root);
    var errEl = $('[data-form-error]', form);

    function current() {
      if (!product) return null;
      var groups = $$('[data-option-index]', root);
      if (!groups.length) {
        return product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];
      }
      var opts = groups.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }
    function apply() {
      var v = current();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'לא זמין'; return; }
      idInput.value = v.id;
      if (priceEl) {
        var h = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) h += ' <s>' + money(v.compare_at_price) + '</s>';
        priceEl.innerHTML = h;
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? A.strings.add : A.strings.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = addBtn.textContent; }
      if (window.history.replaceState && product.variants.length > 1) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    $$('[data-option-index] input', root).forEach(function (i) { i.addEventListener('change', apply); });

    var sw = $('[data-bless-switch]', root), box = $('[data-bless-box]', root);
    if (sw && box) {
      var ta = $('textarea', box), counter = $('[data-bless-count]', box);
      sw.addEventListener('click', function () {
        var on = sw.getAttribute('aria-checked') !== 'true';
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
        box.hidden = !on; ta.disabled = !on;
        if (on) ta.focus();
      });
      if (counter) ta.addEventListener('input', function () { counter.textContent = ta.value.length + '/' + ta.maxLength; });
    }

    form.addEventListener('submit', function (e) {
      if (A.cartType !== 'drawer') return;
      e.preventDefault();
      if (errEl) errEl.hidden = true;
      addBtn.classList.add('is-loading');
      var fd = new FormData(form);
      var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1, properties: {} };
      fd.forEach(function (val, key) {
        if (key.indexOf('properties[') === 0 && key.slice(-1) === ']' && String(val).trim()) item.properties[key.slice(11, -1)] = val;
      });
      A.addItems([item]).catch(function (err) {
        if (errEl) { errEl.textContent = (err && err.description) || A.strings.error; errEl.hidden = false; }
      }).finally(function () { addBtn.classList.remove('is-loading'); });
    });

    var bar = $('.sticky-buy', root);
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    var slides = $('.pdp__slides', root), dots = $$('.pdp__dots i', root);
    if (slides && dots.length) {
      slides.addEventListener('scroll', function () {
        var first = slides.firstElementChild;
        var w = first ? first.getBoundingClientRect().width + 12 : 1;
        var idx = Math.round(Math.abs(slides.scrollLeft) / w);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }
  }

  function initBuilder(root) {
    if (root._on) return; root._on = true;
    var need = parseInt(root.getAttribute('data-need'), 10) || 2;
    var discount = parseInt(root.getAttribute('data-discount'), 10) || 0;
    var items = $$('.b-item:not([disabled])', root);
    var slots = $$('.slot', root);
    var sub = $('[data-b-sub]', root), disc = $('[data-b-disc]', root), tot = $('[data-b-total]', root);
    var note = $('[data-b-note]', root), add = $('[data-b-add]', root);
    var picks = [];
    function countOf(id) { return picks.filter(function (p) { return p.id === id; }).length; }
    function render() {
      slots.forEach(function (s, i) {
        var p = picks[i], label = $('[data-slot-label]', s) || s;
        label.textContent = p ? p.name : s.getAttribute('data-empty');
        s.classList.toggle('is-full', !!p);
        s.disabled = !p;
        s.setAttribute('aria-label', p ? 'הסרת ' + p.name + ' מהסט' : s.getAttribute('data-empty'));
      });
      var total = picks.reduce(function (a, p) { return a + p.price; }, 0);
      var d = picks.length >= need ? discount : 0;
      sub.textContent = money(total);
      disc.textContent = d ? '− ' + money(d) : money(0);
      tot.textContent = money(total - d);
      var left = need - picks.length;
      note.textContent = left <= 0 ? root.getAttribute('data-note-done') : (picks.length && left === 1 ? root.getAttribute('data-note-1') : root.getAttribute('data-note-0'));
      add.disabled = picks.length < need;
      items.forEach(function (b) {
        var c = countOf(b.dataset.variant);
        b.setAttribute('aria-pressed', c ? 'true' : 'false');
        var st = $('[data-b-state]', b);
        if (st) st.textContent = c === 0 ? 'לבחירה' : (c === 1 ? (picks.length < need ? 'נבחר · לחיצה נוספת מוסיפה עוד אחד' : 'נבחר') : 'נבחרו ' + c);
      });
    }
    items.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.dataset.variant;
        if (countOf(id) >= need) picks = picks.filter(function (p) { return p.id !== id; });
        else {
          if (picks.length >= need) picks.shift();
          picks.push({ id: id, name: b.dataset.name, price: parseInt(b.dataset.price, 10) });
        }
        render();
      });
    });
    slots.forEach(function (s, i) {
      s.addEventListener('click', function () { if (picks[i]) { picks.splice(i, 1); render(); } });
    });
    add.addEventListener('click', function () {
      var q = {}, order = [];
      picks.forEach(function (p) { if (!q[p.id]) { q[p.id] = 0; order.push(p.id); } q[p.id] += 1; });
      add.classList.add('is-loading');
      A.addItems(order.map(function (id) { return { id: parseInt(id, 10), quantity: q[id] }; }))
        .then(function () { picks = []; render(); })
        .catch(A.fail)
        .finally(function () { add.classList.remove('is-loading'); });
    });
    render();
  }

  function initFinder(root) {
    if (root._on) return; root._on = true;
    var dataEl = $('script[data-finder-json]', root);
    if (!dataEl) return;
    var recs = JSON.parse(dataEl.textContent);
    var sel = { occasion: null, budget: null };
    var out = $('[data-finder-answer]', root);
    var tpl = $('template[data-finder-tpl]', root);
    function show() {
      if (!sel.occasion) return;
      var pool = recs.filter(function (r) { return r.occasion === sel.occasion; });
      if (sel.budget) {
        var b = pool.filter(function (r) { return r.budget === sel.budget; });
        if (b.length) pool = b;
      }
      var r = pool[0];
      if (!r) return;
      var node = tpl.content.cloneNode(true);
      var img = node.querySelector('[data-f-img]');
      if (r.image) {
        var im = document.createElement('img');
        im.src = r.image; im.alt = ''; im.loading = 'lazy'; im.width = 400; im.height = 500;
        img.appendChild(im);
      } else img.remove();
      node.querySelector('[data-f-title]').textContent = r.title;
      node.querySelector('[data-f-text]').textContent = r.text;
      node.querySelector('[data-f-price]').textContent = r.price ? money(r.price) : '';
      node.querySelector('[data-f-link]').href = r.url;
      var q = node.querySelector('[data-f-add]');
      if (r.variant && r.available) q.setAttribute('data-quick-add', r.variant); else q.remove();
      out.innerHTML = ''; out.appendChild(node);
      out.classList.toggle('is-empty', !r.image);
    }
    $$('.opt', root).forEach(function (o) {
      o.addEventListener('click', function () {
        var g = o.getAttribute('data-group');
        $$('.opt[data-group="' + g + '"]', root).forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        o.setAttribute('aria-pressed', 'true');
        sel[g] = o.getAttribute('data-value');
        show();
      });
    });
  }

  function initAll(scope) {
    $$('[data-product-root]', scope).forEach(initProduct);
    $$('[data-builder]', scope).forEach(initBuilder);
    $$('[data-finder]', scope).forEach(initFinder);
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); A.initAnnounce(); });
})();